"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Main_1 = __importDefault(require("@/components/Main"));
const TableLoader_1 = __importDefault(require("@/components/TableLoader"));
const EvaluatorGroupTable_1 = __importDefault(require("../EvaluatorGroupTable"));
const EvaluatorsToast_1 = __importDefault(require("../EvaluatorsToast"));
const RemoveEvaluatorDialog_1 = __importDefault(require("../RemoveEvaluatorDialog"));
function EvalutorsTableSectionView({ evaluatorsGroups, areEvaluatorsGroupsLoading, }) {
    return (react_1.default.createElement(Main_1.default, null,
        areEvaluatorsGroupsLoading &&
            [...Array(3)]?.map((_, index) => {
                return (react_1.default.createElement(TableLoader_1.default, { key: index, tableLoaderStyle: { height: "250px", marginBottom: "120px" } }));
            }),
        evaluatorsGroups.map((evaluatorGroup) => {
            return react_1.default.createElement(EvaluatorGroupTable_1.default, { key: evaluatorGroup.id, group: evaluatorGroup });
        }),
        react_1.default.createElement(EvaluatorsToast_1.default, null),
        react_1.default.createElement(RemoveEvaluatorDialog_1.default, null)));
}
exports.default = EvalutorsTableSectionView;
